module.exports = __webpack_public_path__ + "img/features-bg_1.1fb00179.png";